import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export function RecipePricing({ form, setForm, effectiveCost, autoIngCost, hasIngCosts }) {
  const costNum = effectiveCost;
  const priceNum = parseFloat(form.selling_price) || 0;
  const marginPct = costNum > 0 && priceNum > 0 ? ((priceNum - costNum) / priceNum * 100) : null;
  const marginColor = marginPct === null ? "" : marginPct >= 65 ? "text-emerald-600" : marginPct >= 45 ? "text-amber-600" : "text-red-600";
  const marginBg = marginPct === null ? "" : marginPct >= 65 ? "bg-emerald-50 border-emerald-200" : marginPct >= 45 ? "bg-amber-50 border-amber-200" : "bg-red-50 border-red-200";
  const marginLabel = marginPct === null ? "" : marginPct >= 65 ? "Marge alt" : marginPct >= 45 ? "Marge acceptable" : "Marge baix";

  return (
    <>
      {/* Preparation */}
      <div>
        <Label>Procés d'elaboració</Label>
        <Textarea placeholder="Passos de preparació..." value={form.preparation_steps} onChange={(e) => setForm({ ...form, preparation_steps: e.target.value })} className="h-24 resize-none" data-testid="recipe-preparation-steps-input" />
      </div>

      {/* Pricing */}
      <div className="border-t pt-4">
        <h3 className="font-semibold text-sm mb-3">Preus i rendibilitat</h3>
        <div className="grid grid-cols-3 gap-3">
          <div>
            <Label>Temps (min)</Label>
            <Input type="number" placeholder="30" value={form.preparation_time} onChange={(e) => setForm({ ...form, preparation_time: e.target.value })} />
          </div>
          <div>
            <Label>Cost manual (€)</Label>
            <Input type="number" step="0.01" placeholder="3.50" value={form.estimated_cost} onChange={(e) => setForm({ ...form, estimated_cost: e.target.value })} disabled={hasIngCosts} className={hasIngCosts ? "opacity-50 cursor-not-allowed" : ""} />
            {hasIngCosts && <p className="text-[10px] text-emerald-600 mt-0.5">Auto: {autoIngCost.toFixed(2)}€</p>}
          </div>
          <div>
            <Label>Preu venda (€)</Label>
            <Input type="number" step="0.01" placeholder="12.00" value={form.selling_price} onChange={(e) => setForm({ ...form, selling_price: e.target.value })} data-testid="recipe-selling-price-input" />
          </div>
        </div>

        {marginPct !== null && (
          <div className={`mt-3 rounded-xl border p-4 ${marginBg}`}>
            <div className="flex items-center justify-between mb-2">
              <p className={`text-sm font-bold ${marginColor}`}>{marginLabel}</p>
              <p className={`text-lg font-bold ${marginColor}`}>{marginPct.toFixed(1)}%</p>
            </div>
            <div className="h-2 bg-white/60 rounded-full overflow-hidden mb-2">
              <div className={`h-full rounded-full transition-all ${marginPct >= 65 ? "bg-emerald-500" : marginPct >= 45 ? "bg-amber-500" : "bg-red-500"}`} style={{ width: `${Math.min(marginPct, 100)}%` }} />
            </div>
            <div className="flex justify-between text-xs text-gray-500">
              <span>Cost: <strong>{costNum.toFixed(2)}€</strong></span>
              <span>Marge brut: <strong>{(priceNum - costNum).toFixed(2)}€</strong></span>
              <span>PVP: <strong>{priceNum.toFixed(2)}€</strong></span>
            </div>
            {marginPct < 45 && (
              <div className="mt-2 pt-2 border-t border-current/10 text-xs">
                <p className={`${marginColor} font-medium`}>Per assolir un marge del 65%, el PVP hauria de ser <strong>{(costNum / 0.35).toFixed(2)}€</strong></p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Conservation */}
      <div className="border-t pt-4">
        <h3 className="font-semibold text-sm mb-3">Conservació</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Label>Vida útil (mesos)</Label>
            <Input type="number" placeholder="12" value={form.shelf_life_months} onChange={(e) => setForm({ ...form, shelf_life_months: e.target.value })} />
          </div>
          <div>
            <Label>Temperatura</Label>
            <Input placeholder="Ex: -18ºC" value={form.storage_temperature} onChange={(e) => setForm({ ...form, storage_temperature: e.target.value })} />
          </div>
        </div>
        <div className="mt-3">
          <Label>Notes de conservació</Label>
          <Textarea placeholder="Ex: No tornar a congelar un cop descongelat..." value={form.storage_notes} onChange={(e) => setForm({ ...form, storage_notes: e.target.value })} className="h-16 resize-none" />
        </div>
      </div>
    </>
  );
}
